import { Column } from '../../../grids';
import { ReactElement } from 'react';
import { formatDate, formatCurrencyOrUndefined } from '../../../../../../ui/src';
import React from 'react';

interface IDrawManualBorrowerColumnProps {
    drawId: number;
    drawNumber: number;
    drawFinalized: boolean;
    needsBorrowerSignature: boolean;
    hasResubmitted: boolean;
    borrowerSubmitted: boolean;
    fundedOn: Date;
    set_isSnackbarOpen: (isSnackbarOpen: boolean) => void;
    set_snackbarMessage: (snackbarMessage: string) => void;
}

export const DrawManualBorrowerColumn = ({
    drawId,
    drawNumber,
    drawFinalized,
    needsBorrowerSignature,
    hasResubmitted,
    borrowerSubmitted,
    fundedOn,
}: IDrawManualBorrowerColumnProps): ReactElement[] => {
    const columnHeaderFunded = () => {
        return (
            <div style={{ width: 90, textAlign: 'center' }}>
                <p>
                    {`DRAW #${drawNumber + 1}`}
                    <br />
                    {`Funded On ${formatDate(fundedOn)}`}
                </p>
            </div>
        );
    };

    const columnHeaderRequesting = () => {
        let subText = borrowerSubmitted ? 'pending' : 'editing';
        if (needsBorrowerSignature) subText = 'adjusted';
        return (
            <div style={{ width: 90, textAlign: 'center' }}>
                <p>
                    {`DRAW #${drawNumber + 1}`}
                    <br />({subText})
                </p>
            </div>
        );
    };

    if (drawFinalized) {
        return [
            <Column
                name={`Column${drawId}-${drawNumber}`}
                key={`Column${drawId}-${drawNumber}`}
                dataField={`drawItems-funded-${drawId}-${drawNumber}`}
                allowEditing={false}
                headerCellRender={columnHeaderFunded}
                cellRender={(cellData) => {
                    const dataItem = cellData.data?.drawItems?.find((item) => item.drawNumber == drawNumber);
                    return formatCurrencyOrUndefined(dataItem?.funded, 2);
                }}
                caption={`DRAW #${drawNumber + 1}`}
                format={'currency'}
                alignment={'right'}
                allowResizing={false}
                minWidth={100}
                width={100}
            />,
        ];
    }

    if (needsBorrowerSignature || hasResubmitted) {
        return [
            <Column
                name={`Column${drawId}-${drawNumber}`}
                key={`Column${drawId}-${drawNumber}`}
                dataField={`drawItems-funded-${drawId}-${drawNumber}`}
                allowEditing={false}
                headerCellRender={columnHeaderRequesting}
                cellRender={(cellData) => {
                    const dataItem = cellData.data?.drawItems?.find((item) => item.drawNumber == drawNumber);
                    return formatCurrencyOrUndefined(dataItem?.funded, 2);
                }}
                caption={`DRAW #${drawNumber + 1}`}
                format={'currency'}
                alignment={'right'}
                allowResizing={false}
                minWidth={100}
                width={100}
            />,
        ];
    }

    return [
        <Column
            name={`Column${drawId}-${drawNumber}`}
            key={`Column${drawId}-${drawNumber}`}
            dataType='number'
            editorOptions={{
                dataType: 'number',
                format: { type: 'currency', precision: 2 },
                step: 0,
            }}
            allowEditing={!borrowerSubmitted}
            headerCellRender={columnHeaderRequesting}
            dataField={`drawItems-borrowerRequest-${drawId}-${drawNumber}`}
            cellRender={(cellData) => {
                const dataItem = cellData.data?.drawItems?.find((item) => item.drawNumber == drawNumber);
                return formatCurrencyOrUndefined(dataItem?.borrowerRequest, 2);
            }}
            caption='BORROWER REQUEST'
            format={'currency'}
            alignment={'right'}
            allowResizing={false}
            minWidth={100}
            width={100}
        />,
    ];
};
